import React, { FunctionComponent } from 'react';
import BlocQuestions from '../components/BlocQuestions';
import Breadcrumb from '../components/Breadcrumb';
import SearchBar from '../components/searchbar/SearchBar';
import { DefaultFAQPagesProps, IQuestion, IQuestionSection } from '../interfaces';

interface ThematiqueProps extends DefaultFAQPagesProps {
  item: IQuestionSection;
  questions: IQuestion[];
  staticContents?: Record<string, string>;
}

const Thematique: FunctionComponent<ThematiqueProps> = ({item, questions, breadcrumbHomeIcon, breadcrumbSeparatorIcon, langId, shopInfos, hostApi, staticContents, baseLangUrl}) => {
  return (
    <div className={"container faq display-flex flex-column justify-content-between h-100 " + shopInfos.Ref}>
      <div className="h-100">
        <Breadcrumb
          homeIcon={breadcrumbHomeIcon}
          separatorIcon={breadcrumbSeparatorIcon}
          baseLangUrl={baseLangUrl}
          items={[
            {
              title: staticContents?.['BREADCRUMB_FAQ_HOME'] ?? "Besoin d'aide",
              url: `/${baseLangUrl}/help`
            },
            {
              title: item.label
            }
          ]}
        />
        <SearchBar hostApi={hostApi} langId={langId} shopId={shopInfos.idBoutique} placeholder={staticContents?.['PLACEHOLDER_SEARCHBAR']} />
        <hr className="faq-hr-h mb-5" />
        <h1 className="font22 mt4 mb3">{item.h1 && item.h1 !== '' ? item.h1 : item.label}</h1>
        <BlocQuestions items={questions} baseLangUrl={baseLangUrl} />
      </div>
  </div>
  );
};

export default Thematique;